<template>
    <div class="finance-balance">
        <div class="flex">
            <div class="item text-center">
                <div class="title">{{ $t('Finance.Withdrawable') }}</div>
                <div class="money">￥8.82</div>
                <div @click="balanceWithdraw" class="btn">{{ $t('Finance.Bank.money') }}</div>
            </div>
            <div class="item text-center">
                <div class="title">{{ $t('Finance.Bank.mybankcard') }}</div>
                <div class="text">****&nbsp;***8&nbsp;713&nbsp;</div>
                <div class="text">{{ $t('Finance.Bank.ConstructionBank') }}</div>
                <div @click="EditBank" class="btn">{{ $t('tooltip.edit') }}</div>
            </div>
            <div class="item text-center">
                <div class="title">{{ $t('Finance.Bank.TwoDimensionalCode') }}</div>
                <div class="text">{{ $t('Finance.ForPCPayment') }}</div>
                <file-upload>
                    <div class="pic"><i class="el-icon-plus"></i></div>
                </file-upload>
            </div>
        </div>
        <el-select v-model="form.type" :placeholder="$t('Common.please_choose')">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value" />
        </el-select>
        <el-table
            :data="tableData"
            style="width: 100%;margin: 15px 0;"
            border>
            <el-table-column fixed prop="date" :label="$t('Sell.TicketPrint.type')" />
            <el-table-column prop="name" :label="$t('Course.Appoint.amt')" />
            <el-table-column prop="province" :label="$t('Common.remark')" />
            <el-table-column prop="city" :label="$t('Reception.Fourth.status')" />
            <el-table-column prop="address" :label="$t('Finance.dealtime')" />
            <el-table-column prop="zip" :label="$t('Finance.Settling_time')" />
        </el-table>
        <el-pagination
            v-if="tableData.length"
            class="text-right"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total" />

         <!-- 提现 -->
        <withdraw-form ref="withdraw" />
        <!-- 银行卡 -->
        <bankcard-form ref="bankcard" />
    </div>
</template>

<script>
import FileUpload from '@/components/base/FileUpload';
import WithdrawForm from '@/components/Dialog/Finance/WithdrawForm.vue';
import BankcardForm from '@/components/Dialog/Finance/BankcardForm.vue';

export default {
    components: {
        FileUpload,
        WithdrawForm,
        BankcardForm,
    },
    data() {
        return {
            options: [
                {
                    value: '0',
                    label: this.$t('Finance.alltype'),
                }, {
                    value: '1',
                    label: this.$t('Sell.Pay.buy'),
                }, {
                    value: '2',
                    label: this.$t('Finance.Bank.money'),
                },
            ],
            form: {
                page: 1,
                type: '0',
            },
            tableData: [],
            pagination: {
                total: 0,
                size: 10,
            },
        };
    },
    watch: {
    },
    methods: {
        fetchData() {},
        balanceWithdraw() {
            if (this.$$filterPermission('财务-余额管理-提现及银行卡设置'))
                this.$refs.withdraw.open();
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        EditBank() {
            this.$refs.bankcard.open();
        },
    },
};
</script>

<style lang="scss">
.finance-balance {
    .item {
        width: calc(100% / 3);
        margin-left: 1%;
        padding: 50px 15px;
        margin-bottom: 15px;
        border: 1px solid #e6e6e6;

        &:first-child {
            margin-left: 0;
        }
    }
    .title {
        font-size: 13px;
        font-weight: 400;
        color: #4c4c4c;
        margin-bottom: 15px;
    }
    .money {
        margin: 25px 0;
        font-size: 20px;
        color: #05abef;
    }
    .btn {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 13px;
        background: #05abef;
        border: 0 none;
        color: #fff;
        border-radius: 3px;
        cursor: pointer;
        margin-bottom: 20px;
        width: 140px;
    }
    .pic {
        width: 90px;
        height: 90px;
        background: #f0f0f0;
        position: relative;

        .el-icon-plus {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 30px;
            font-weight: 500;
            color: #fff;
        }
    }
    .text {
        font-size: 13px;
        margin-bottom: 15px;
    }
}
</style>
